// extracted by mini-css-extract-plugin
export var container = "_1o-0";
export var disabled = "_1o-4";
export var fullWidth = "_1o-3";
export var lined = "_1o-1";
export var selected = "_1o-5";
export var tab = "_1o-2";